<template lang="pug">
.cooperation-system-select-modal
  b-modal(v-model="_value" size="md" title="連携システムからファイル取得" @ok="ok" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
    .cooperation-system-select-body
      .register-body
        //- select system
        FormInputSelect(v-model="cooperationSystem" :options="_cooperationSystemOptions" key-name="連携システム" name="cooperation-system"
          :validation-rules="{ required: true }" :styles="{ 'max-width': '430px' }" @change="changeCooperationSystem" required)
        
        //- goodTree and careTree
        .good-tree(v-if="_selectedGoodTree")
          //- 事業所名（サービス種別）
          FormInputSelect(v-model="serviceType" :options="_serviceTypeOptions" key-name="事業所名（サービス種別）" name="service-type"
            :validation-rules="{ required: true }" @change="changeGoodTreeServiceType" :styles="{ 'max-width': '430px' }" required)
          //- 文書種類
          FormInputSelect(v-model="documentType" :options="_goodTreeOptions" key-name="文書種類" name="document-type"
            :validation-rules="{ required: true }" @change="changeGoodTreeDocumentType" :styles="{ 'max-width': '430px' }" required)
          //- サービス利用月
          FormInputSelect(v-model="monthOfUse" :options="_goodTreeMonthOfUseOptions" key-name="サービス利用月" name="month-of-use"
            :validation-rules="{ required: true }" @change="changeGoodTreeMonthOfUse" :styles="{ 'max-width': '430px' }" required)
          //- ファイル(作成日時)
          FormInputSelect(v-model="created" :options="_goodTreeCreatedOptions" key-name="ファイル" name="created"
            :validation-rules="{ required: true }" :styles="{ 'max-width': '430px' }" required)

        //- iMedic
        .i-medic(v-if="_selectedIMedic")
          //- 事業所名（サービス種別）
          FormInputSelect(v-model="serviceType" :options="_serviceTypeOptions" key-name="事業所名（サービス種別）" name="service-type"
            :validation-rules="{ required: true }" @change="changeIMedicServiceType" :styles="{ 'max-width': '430px' }" required)
          //- 文書種類
          FormInputSelect(v-model="documentType" :options="_iMedicOptions" key-name="文書種類" name="document-type"
            :validation-rules="{ required: true }" @change="changeIMedicDocumentType" :styles="{ 'max-width': '430px' }" required)
          //- サービス利用月
          FormInputSelect(v-model="monthOfUse" :options="_iMedicMonthOfUseOptions" key-name="サービス利用月" name="month-of-use"
            :validation-rules="{ required: true }" @change="changeIMedicMonthOfUse" :styles="{ 'max-width': '430px' }" required)
          //- ファイル(作成日時)
          FormInputSelect(v-model="created" :options="_iMedicCreatedOptions" key-name="ファイル" name="created"
            :validation-rules="{ required: true }" :styles="{ 'max-width': '430px' }" required)

        //- toukei (福祉見聞録)
        .toukei(v-if="_selectedToukei")
          //- 事業所名（サービス種別）
          FormInputSelect(v-model="serviceType" :options="_serviceTypeOptions" key-name="事業所名（サービス種別）" name="service-type"
            :validation-rules="{ required: true }" @change="changeToukeiServiceType" :styles="{ 'max-width': '430px' }" required)
          //- 文書種類
          FormInputSelect(v-model="documentType" :options="_toukeiOptions" key-name="文書種類" name="document-type"
            :validation-rules="{ required: true }" @change="changeToukeiDocumentType" :styles="{ 'max-width': '430px' }" required)
          //- サービス利用月
          FormInputSelect(v-model="monthOfUse" :options="_toukeiMonthOfUseOptions" key-name="サービス利用月" name="month-of-use"
            :validation-rules="{ required: true }" @change="changeToukeiMonthOfUse" :styles="{ 'max-width': '430px' }" required)
          //- ファイル(作成日時)
          FormInputSelect(v-model="created" :options="_toukeiCreatedOptions" key-name="ファイル" name="created"
            :validation-rules="{ required: true }" :styles="{ 'max-width': '430px' }" required)

    template(#modal-footer="{ ok, cancel }")
      ValidationAlert(v-model="showValidationAlert")
      b-button.btn.modal-get-files-btn(@click="ok") ファイル取得
      b-button.btn.modal-cancel-btn(@click="cancel") キャンセル
      
  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import FacilitiesService from "@/commons/services/Facilities";
import GoodTreeFilesService, { GoodTreeFile, GoodTreeFilesGetModel, InvoiceFileByUseOfMonth, ReceiptFileByUseOfMonth } from "@/commons/services/GoodTreeFiles";
import IMedicFilesService, { FileByUseOfMonth as IMedicFileByUseOfMonth, IMedicFile, IMedicFilesGetModel } from "@/commons/services/IMedicFiles";
import ToukeiFilesService, { FileByUseOfMonth as ToukeiFileByUseOfMonth, ToukeiFile, ToukeiFilesGetModel } from "@/commons/services/ToukeiFiles";

import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";

/**
 * ### 文書送付、「利用者毎に異なる文書」のファイル選択モーダル
 */
@Component({
  components: {
    FormInputSelect,
    PageLoading,
    ValidationAlert
  },
  $_veeValidate: { validator: "new" }
})
export default class CooperationSystemSelectModal extends Vue {
  /** グッドツリー連携ファイルサービス */
  @Inject("GoodTreeFilesService") goodTreeFilesService!: GoodTreeFilesService;
  /** iMedic連携ファイルサービス */
  @Inject("IMedicFilesService") iMedicFilesService!: IMedicFilesService;
  /** 福祉見聞録（東経システム）連携ファイルサービス */
  @Inject("ToukeiFilesService") toukeiFilesService!: ToukeiFilesService;

  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 連携システム */
  cooperationSystem: string | null = null;
  /** サービス種別 */
  serviceType: string | null = null;

  /** グッドツリー社連携ファイル */
  goodTreeFiles: GoodTreeFilesGetModel | null = null;
  /** グッドツリー社連携情報 */
  goodTreeOption: GoodTreeOption = {
    options: [],
    monthOfUseOptions: []
  };

  /** iMedic連携ファイル */
  iMedicFiles: IMedicFilesGetModel | null = null;
  /** iMedic連携情報 */
  iMedicOption: IMedicOption = {
    options: [],
    monthOfUseOptions: []
  };

  /** 福祉見聞録（東経システム）連携ファイル */
  toukeiFiles: ToukeiFilesGetModel | null = null;
  /** 福祉見聞録（東経システム）連携情報 */
  toukeiOption: ToukeiOption = {
    options: [],
    monthOfUseOptions: []
  };

  /** 文書種別 */
  documentType: number | null = null;
  /** 利用月 */
  monthOfUse: number | null = null;
  /** 作成日時 */
  created: number | null = null;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _cooperationSystemOptions(): Array<{ value: number | string; label: string }> {
    const options: Array<{ value: number | string; label: string }> = [];
    if (userStore.facility.cooperationSystems.careTree == true) {
      options.push({
        value: "careTree",
        label: "ケア樹"
      });
    }
    if (userStore.facility.cooperationSystems.hitomeQTree == true) {
      options.push({
        value: "hitomeQTree",
        label: "HitomeQ ツリー"
      });
    }
    if (userStore.facility.cooperationSystems.scopReceipt == true) {
      options.push({
        value: "scopReceipt",
        label: "SCOP receipt"
      });
    }
    if (userStore.facility.cooperationSystems.iMedic == true) {
      options.push({
        value: "iMedic",
        label: "i-MEDIC Plus 介護"
      });
    }
    if (userStore.facility.cooperationSystems.toukei == true) {
      options.push({
        value: "toukei",
        label: "福祉見聞録"
      });
    }
    return options;
  }

  get _selectedGoodTree(): boolean {
    if (this.cooperationSystem == "careTree" || this.cooperationSystem == "hitomeQTree" || this.cooperationSystem == "scopReceipt") {
      return true;
    }
    return false;
  }

  get _serviceTypeOptions(): Array<{ value: number | string; label: string }> {
    const options: Array<{ value: number | string; label: string }> = [];
    for (const careOfficeNumber of userStore.facility.careOfficeNumbers) {
      const serviceTypeName: string | undefined = FacilitiesService.serviceNameMapByType.get(careOfficeNumber.careOfficeServiceType);
      if (careOfficeNumber.careOfficeName && serviceTypeName) {
        options.push({
          value: `${careOfficeNumber.careOfficeNumber}_${careOfficeNumber.careOfficeServiceType}`,
          label: `${careOfficeNumber.careOfficeName}（${serviceTypeName}）`
        });
      } else if (serviceTypeName) {
        options.push({
          value: `${careOfficeNumber.careOfficeNumber}_${careOfficeNumber.careOfficeServiceType}`,
          label: `${serviceTypeName}`
        });
      }
    }
    return options;
  }

  get _goodTreeOptions(): Array<{ value: number | string; label: string }> {
    if (this.serviceType == null) {
      return [];
    }
    return this.goodTreeOption.options;
  }

  get _goodTreeMonthOfUseOptions(): Array<{ value: number | string; label: string }> {
    if (this.documentType == null) {
      return [];
    }
    return this.goodTreeOption.monthOfUseOptions[this.documentType].options;
  }

  get _goodTreeCreatedOptions(): Array<{ value: number | string; label: string }> {
    if (this.documentType == null || this.monthOfUse == null) {
      return [];
    }
    return this.goodTreeOption.monthOfUseOptions[this.documentType].createdOptions[this.monthOfUse].options;
  }

  get _selectedIMedic(): boolean {
    if (this.cooperationSystem == "iMedic") {
      return true;
    }
    return false;
  }

  get _iMedicOptions(): Array<{ value: number | string; label: string }> {
    if (this.serviceType == null) {
      return [];
    }
    return this.iMedicOption.options;
  }

  get _iMedicMonthOfUseOptions(): Array<{ value: number | string; label: string }> {
    if (this.documentType == null) {
      return [];
    }
    return this.iMedicOption.monthOfUseOptions[this.documentType].options;
  }

  get _iMedicCreatedOptions(): Array<{ value: number | string; label: string }> {
    if (this.documentType == null || this.monthOfUse == null) {
      return [];
    }
    return this.iMedicOption.monthOfUseOptions[this.documentType].createdOptions[this.monthOfUse].options;
  }

  get _selectedToukei(): boolean {
    if (this.cooperationSystem == "toukei") {
      return true;
    }
    return false;
  }

  get _toukeiOptions(): Array<{ value: number | string; label: string }> {
    if (this.serviceType == null) {
      return [];
    }
    return this.toukeiOption.options;
  }

  get _toukeiMonthOfUseOptions(): Array<{ value: number | string; label: string }> {
    if (this.documentType == null) {
      return [];
    }
    return this.toukeiOption.monthOfUseOptions[this.documentType].options;
  }

  get _toukeiCreatedOptions(): Array<{ value: number | string; label: string }> {
    if (this.documentType == null || this.monthOfUse == null) {
      return [];
    }
    return this.toukeiOption.monthOfUseOptions[this.documentType].createdOptions[this.monthOfUse].options;
  }

  /**
   * ### 連携システム変更イベント
   *
   * - 連携種別選択後に入力する情報を初期化する
   */
  changeCooperationSystem(): void {
    this.serviceType = null;
    this.documentType = null;
    this.monthOfUse = null;
    this.created = null;
    return;
  }

  /**
   * ### グッドツリー社のサービス種別変更イベント
   */
  async changeGoodTreeServiceType(): Promise<void> {
    this.documentType = null;
    this.monthOfUse = null;
    this.created = null;

    if (this.serviceType != null) {
      this.isBusy = true;
      this.loadingMessage = "読込み中...";

      const files: GoodTreeFilesGetModel = await this.goodTreeFilesService.gets(userStore, this.serviceType);
      this.goodTreeFiles = files;
      const goodTreeOption: GoodTreeOption = this.createGoodTreeOption(files);
      this.goodTreeOption = goodTreeOption;

      this.isBusy = false;
    } else {
      this.goodTreeOption = {
        options: [],
        monthOfUseOptions: []
      };
    }
    return;
  }

  /** 文書種類毎の利用月選択肢、作成日時でネストした選択肢を作成する */
  createGoodTreeOption(goodTreeFiles: GoodTreeFilesGetModel): GoodTreeOption {
    return {
      options: [
        { value: 0, label: "請求書" },
        { value: 1, label: "領収書" }
      ],
      monthOfUseOptions: [this.createGoodTreeOptionByMonthOfUse(goodTreeFiles.invoices), this.createGoodTreeOptionByMonthOfUse(goodTreeFiles.receipts)]
    };
  }

  /** 文書種類毎の利用月選択肢、作成日時でネストした選択肢を作成する */
  createGoodTreeOptionByMonthOfUse(files: Array<InvoiceFileByUseOfMonth | ReceiptFileByUseOfMonth>): GoodTreeOptionByMonthOfUse {
    const optionsByMonthOfUse: GoodTreeOptionByMonthOfUse = {
      options: [],
      createdOptions: []
    };

    for (let i = 0; i < files.length; i++) {
      optionsByMonthOfUse.options.push({
        value: i,
        label: this.$dateUtil.convertNumberToString(Number(`${files[i].useOfMonth}01000000000`), "yyyy年mm月")
      });
      const createdOption: GoodTreeOptionByCreated = {
        options: [],
        files: []
      };
      // 作成日時単位のループ
      for (let j = 0; j < files[i].filesByCreated.length; j++) {
        const label: string = this.$dateUtil.convertNumberToString(files[i].filesByCreated[j].created, "yyyy年mm月dd日 hh:MM作成");
        createdOption.options.push({
          value: j,
          label: j == 0 ? `最新（${label}）` : label
        });
        createdOption.files = files[i].filesByCreated[j].files;
      }
      optionsByMonthOfUse.createdOptions.push(createdOption);
    }

    return optionsByMonthOfUse;
  }

  changeGoodTreeDocumentType(): void {
    this.monthOfUse = null;
    return;
  }

  changeGoodTreeMonthOfUse(): void {
    this.created = null;
    return;
  }

  /**
   * ### iMedicのサービス種別変更イベント
   */
  async changeIMedicServiceType(): Promise<void> {
    this.documentType = null;
    this.monthOfUse = null;
    this.created = null;

    if (this.serviceType != null) {
      this.isBusy = true;
      this.loadingMessage = "読込み中...";

      const files: IMedicFilesGetModel = await this.iMedicFilesService.gets(userStore, this.serviceType);
      this.iMedicFiles = files;
      const iMedicOption: IMedicOption = this.createIMedicOption(files);
      this.iMedicOption = iMedicOption;

      this.isBusy = false;
    } else {
      this.iMedicOption = {
        options: [],
        monthOfUseOptions: []
      };
    }
    return;
  }

  /** 文書種類毎の利用月選択肢、作成日時でネストした選択肢を作成する */
  createIMedicOption(iMedicFilesGetModel: IMedicFilesGetModel): IMedicOption {
    return {
      options: [
        { value: IMedicOptionValue.REHABILITATION_PLAN_FILES, label: "リハビリ計画書" },
        { value: IMedicOptionValue.ORAL_FUNCTION_IMPROVEMENT_PLAN_FILES, label: "口腔機能向上計画書" },
        { value: IMedicOptionValue.BEDSORE_MANAGEMENT_PLAN_FILES, label: "褥瘡マネジメント計画書" },
        { value: IMedicOptionValue.EXCRETION_SUPPORT_PLAN_FILES, label: "排泄支援計画書" },
        { value: IMedicOptionValue.INDEPENDENCE_SUPPORT_EVALUATION_PLAN_FILES, label: "自立支援評価・計画書" },
        { value: IMedicOptionValue.NUTRITION_CARE_PLAN_FILES, label: "栄養ケア計画書" },
        { value: IMedicOptionValue.COUNTER_INVOICE_BILL_FILES, label: "窓口請求書_請求書" },
        { value: IMedicOptionValue.COUNTER_INVOICE_RECEIPT_FILES, label: "窓口請求書_領収書" },
        { value: IMedicOptionValue.COMPREHENSIVE_PLAN_FILES, label: "総合計画書" }
      ],
      monthOfUseOptions: [
        this.createIMedicOptionByMonthOfUse(iMedicFilesGetModel.rehabilitationPlanFiles),
        this.createIMedicOptionByMonthOfUse(iMedicFilesGetModel.oralFunctionImprovementPlanFiles),
        this.createIMedicOptionByMonthOfUse(iMedicFilesGetModel.bedsoreManagementPlanFiles),
        this.createIMedicOptionByMonthOfUse(iMedicFilesGetModel.excretionSupportPlanFiles),
        this.createIMedicOptionByMonthOfUse(iMedicFilesGetModel.independenceSupportEvaluationPlanFiles),
        this.createIMedicOptionByMonthOfUse(iMedicFilesGetModel.nutritionCarePlanFiles),
        this.createIMedicOptionByMonthOfUse(iMedicFilesGetModel.counterInvoiceBillFiles),
        this.createIMedicOptionByMonthOfUse(iMedicFilesGetModel.counterInvoiceReceiptFiles),
        this.createIMedicOptionByMonthOfUse(iMedicFilesGetModel.comprehensivePlanFiles)
      ]
    };
  }

  /** 文書種類毎の利用月選択肢、作成日時でネストした選択肢を作成する */
  createIMedicOptionByMonthOfUse(files: Array<IMedicFileByUseOfMonth>): IMedicOptionByMonthOfUse {
    const optionsByMonthOfUse: IMedicOptionByMonthOfUse = {
      options: [],
      createdOptions: []
    };

    for (let i = 0; i < files.length; i++) {
      optionsByMonthOfUse.options.push({
        value: i,
        label: this.$dateUtil.convertNumberToString(Number(`${files[i].useOfMonth}01000000000`), "yyyy年mm月")
      });
      const createdOption: IMedicOptionByCreated = {
        options: [],
        files: []
      };
      // 作成日時単位のループ
      for (let j = 0; j < files[i].filesByCreated.length; j++) {
        const label: string = this.$dateUtil.convertNumberToString(files[i].filesByCreated[j].created, "yyyy年mm月dd日 hh:MM作成");
        createdOption.options.push({
          value: j,
          label: j == 0 ? `最新（${label}）` : label
        });
        createdOption.files = files[i].filesByCreated[j].files;
      }
      optionsByMonthOfUse.createdOptions.push(createdOption);
    }

    return optionsByMonthOfUse;
  }

  changeIMedicDocumentType(): void {
    this.monthOfUse = null;
    return;
  }

  changeIMedicMonthOfUse(): void {
    this.created = null;
    return;
  }

  /**
   * ### 福祉見聞録（東経システム）のサービス種別変更イベント
   */
  async changeToukeiServiceType(): Promise<void> {
    this.documentType = null;
    this.monthOfUse = null;
    this.created = null;

    if (this.serviceType != null) {
      this.isBusy = true;
      this.loadingMessage = "読込み中...";

      const files: ToukeiFilesGetModel = await this.toukeiFilesService.gets(userStore, this.serviceType);
      this.toukeiFiles = files;
      const toukeiOption: ToukeiOption = this.createToukeiOption(files);
      this.toukeiOption = toukeiOption;

      this.isBusy = false;
    } else {
      this.toukeiOption = {
        options: [],
        monthOfUseOptions: []
      };
    }
    return;
  }

  /** 文書種類毎の利用月選択肢、作成日時でネストした選択肢を作成する */
  createToukeiOption(toukeiFilesGetModel: ToukeiFilesGetModel): ToukeiOption {
    return {
      options: [
        { value: ToukeiOptionValue.COMBINED_INVOICE_FILES, label: "合算請求書" },
        { value: ToukeiOptionValue.COMBINED_RECEIPT_FILES, label: "合算領収書" },
        { value: ToukeiOptionValue.INVOICE_FILES, label: "請求書" },
        { value: ToukeiOptionValue.RECEIPT_FILES, label: "領収書" }
      ],
      monthOfUseOptions: [
        this.createToukeiOptionByMonthOfUse(toukeiFilesGetModel.combinedInvoiceFiles),
        this.createToukeiOptionByMonthOfUse(toukeiFilesGetModel.combinedReceiptFiles),
        this.createToukeiOptionByMonthOfUse(toukeiFilesGetModel.invoiceFiles),
        this.createToukeiOptionByMonthOfUse(toukeiFilesGetModel.receiptFiles)
      ]
    };
  }

  /** 文書種類毎の利用月選択肢、作成日時でネストした選択肢を作成する */
  createToukeiOptionByMonthOfUse(files: Array<ToukeiFileByUseOfMonth>): ToukeiOptionByMonthOfUse {
    const optionsByMonthOfUse: ToukeiOptionByMonthOfUse = {
      options: [],
      createdOptions: []
    };

    for (let i = 0; i < files.length; i++) {
      optionsByMonthOfUse.options.push({
        value: i,
        label: this.$dateUtil.convertNumberToString(Number(`${files[i].useOfMonth}01000000000`), "yyyy年mm月")
      });
      const createdOption: ToukeiOptionByCreated = {
        options: [],
        files: []
      };
      // 作成日時単位のループ
      for (let j = 0; j < files[i].filesByCreated.length; j++) {
        const label: string = this.$dateUtil.convertNumberToString(files[i].filesByCreated[j].created, "yyyy年mm月dd日 hh:MM作成");
        createdOption.options.push({
          value: j,
          label: j == 0 ? `最新（${label}）` : label
        });
        createdOption.files = files[i].filesByCreated[j].files;
      }
      optionsByMonthOfUse.createdOptions.push(createdOption);
    }

    return optionsByMonthOfUse;
  }

  changeToukeiDocumentType(): void {
    this.monthOfUse = null;
    return;
  }

  changeToukeiMonthOfUse(): void {
    this.created = null;
    return;
  }

  async ok(modalEvent: any): Promise<void> {
    modalEvent.preventDefault(); // function終了後に自動でモーダルが非表示にならないようにする

    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      // 各連携システム毎に親コンポーネントへ通知する
      switch (this.cooperationSystem) {
        // ケア樹、hitomeQツリー
        case "careTree":
        case "hitomeQTree":
        case "scopReceipt": {
          const files: GoodTreeFilesGetModel = this.goodTreeFiles as GoodTreeFilesGetModel;
          const monthOfUse: number = this.monthOfUse as number;
          const created: number = this.created as number;

          switch (this.documentType) {
            case 0: {
              this.$emit("okByGoodTree", files.invoices[monthOfUse].filesByCreated[created].files);
              break;
            }
            case 1: {
              this.$emit("okByGoodTree", files.receipts[monthOfUse].filesByCreated[created].files);
              break;
            }
          }
          break;
        }
        // i-medic
        case "iMedic": {
          const files: IMedicFilesGetModel = this.iMedicFiles as IMedicFilesGetModel;
          const monthOfUse: number = this.monthOfUse as number;
          const created: number = this.created as number;

          switch (this.documentType as number) {
            case IMedicOptionValue.REHABILITATION_PLAN_FILES: {
              this.$emit("okByIMedic", files.rehabilitationPlanFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
            case IMedicOptionValue.ORAL_FUNCTION_IMPROVEMENT_PLAN_FILES: {
              this.$emit("okByIMedic", files.oralFunctionImprovementPlanFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
            case IMedicOptionValue.BEDSORE_MANAGEMENT_PLAN_FILES: {
              this.$emit("okByIMedic", files.bedsoreManagementPlanFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
            case IMedicOptionValue.EXCRETION_SUPPORT_PLAN_FILES: {
              this.$emit("okByIMedic", files.excretionSupportPlanFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
            case IMedicOptionValue.INDEPENDENCE_SUPPORT_EVALUATION_PLAN_FILES: {
              this.$emit("okByIMedic", files.independenceSupportEvaluationPlanFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
            case IMedicOptionValue.NUTRITION_CARE_PLAN_FILES: {
              this.$emit("okByIMedic", files.nutritionCarePlanFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
            case IMedicOptionValue.COUNTER_INVOICE_BILL_FILES: {
              this.$emit("okByIMedic", files.counterInvoiceBillFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
            case IMedicOptionValue.COUNTER_INVOICE_RECEIPT_FILES: {
              this.$emit("okByIMedic", files.counterInvoiceReceiptFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
            case IMedicOptionValue.COMPREHENSIVE_PLAN_FILES: {
              this.$emit("okByIMedic", files.comprehensivePlanFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
          }
          break;
        }
        // 福祉見聞録（東経システム）
        case "toukei": {
          const files: ToukeiFilesGetModel = this.toukeiFiles as ToukeiFilesGetModel;
          const monthOfUse: number = this.monthOfUse as number;
          const created: number = this.created as number;

          switch (this.documentType as number) {
            case ToukeiOptionValue.COMBINED_INVOICE_FILES: {
              this.$emit("okByToukei", files.combinedInvoiceFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
            case ToukeiOptionValue.COMBINED_RECEIPT_FILES: {
              this.$emit("okByToukei", files.combinedReceiptFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
            case ToukeiOptionValue.INVOICE_FILES: {
              this.$emit("okByToukei", files.invoiceFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
            case ToukeiOptionValue.RECEIPT_FILES: {
              this.$emit("okByToukei", files.receiptFiles[monthOfUse].filesByCreated[created].files);
              break;
            }
          }
          break;
        }
      }

      this.$emit("input", false); // エラーではないので自身（モーダル）を非表示にする
      this.resetInput();
    } else {
      this.showValidationAlert = true;
    }
  }

  cancel(): void {
    this.showValidationAlert = false;
    this.resetInput();
    this.$emit("cancel");
    return;
  }

  resetInput(): void {
    this.cooperationSystem = null;
    // グッドツリー社連携情報
    this.goodTreeFiles = null;
    this.iMedicFiles = null;
    this.toukeiFiles = null;
    this.serviceType = null;
    this.documentType = null;
    this.monthOfUse = null;
    this.created = null;

    return;
  }
}

export interface GoodTreeOption {
  /** 文書種別 */
  options: Array<{ value: number | string; label: string }>;
  /** 文書種類毎のサービス利用月情報 */
  monthOfUseOptions: Array<GoodTreeOptionByMonthOfUse>;
}

export interface GoodTreeOptionByMonthOfUse {
  /** サービス利用月選択肢 */
  options: Array<{ value: number | string; label: string }>;
  /** サービス利用月毎の更新日時情報 */
  createdOptions: Array<GoodTreeOptionByCreated>;
}

export interface GoodTreeOptionByCreated {
  /** 更新日時選択肢 */
  options: Array<{ value: number | string; label: string }>;
  /** ファイル */
  files: Array<GoodTreeFile>;
}

export interface IMedicOption {
  /** 文書種別 */
  options: Array<{ value: number | string; label: string }>;
  /** 文書種類毎のサービス利用月情報 */
  monthOfUseOptions: Array<IMedicOptionByMonthOfUse>;
}

export enum IMedicOptionValue {
  /** リハビリ計画書 */
  REHABILITATION_PLAN_FILES = 0,
  /** 口腔機能向上計画書 */
  ORAL_FUNCTION_IMPROVEMENT_PLAN_FILES = 1,
  /** 褥瘡マネジメント計画書 */
  BEDSORE_MANAGEMENT_PLAN_FILES = 2,
  /** 排泄支援計画書 */
  EXCRETION_SUPPORT_PLAN_FILES = 3,
  /** 自立支援評価・計画書 */
  INDEPENDENCE_SUPPORT_EVALUATION_PLAN_FILES = 4,
  /** 栄養ケア計画書 */
  NUTRITION_CARE_PLAN_FILES = 5,
  /** 窓口請求書_請求書 */
  COUNTER_INVOICE_BILL_FILES = 6,
  /** 窓口請求書_領収書 */
  COUNTER_INVOICE_RECEIPT_FILES = 7,
  /** 総合計画書 */
  COMPREHENSIVE_PLAN_FILES = 8
}

export interface IMedicOptionByMonthOfUse {
  /** サービス利用月選択肢 */
  options: Array<{ value: number | string; label: string }>;
  /** サービス利用月毎の更新日時情報 */
  createdOptions: Array<IMedicOptionByCreated>;
}

export interface IMedicOptionByCreated {
  /** 更新日時選択肢 */
  options: Array<{ value: number | string; label: string }>;
  /** ファイル */
  files: Array<IMedicFile>;
}

export interface ToukeiOption {
  /** 文書種別 */
  options: Array<{ value: number | string; label: string }>;
  /** 文書種類毎のサービス利用月情報 */
  monthOfUseOptions: Array<ToukeiOptionByMonthOfUse>;
}

export enum ToukeiOptionValue {
  /** 合算請求書 */
  COMBINED_INVOICE_FILES = 0,
  /** 合算領収書 */
  COMBINED_RECEIPT_FILES = 1,
  /** 請求書 */
  INVOICE_FILES = 2,
  /** 領収書 */
  RECEIPT_FILES = 3
}

export interface ToukeiOptionByMonthOfUse {
  /** サービス利用月選択肢 */
  options: Array<{ value: number | string; label: string }>;
  /** サービス利用月毎の更新日時情報 */
  createdOptions: Array<ToukeiOptionByCreated>;
}

export interface ToukeiOptionByCreated {
  /** 更新日時選択肢 */
  options: Array<{ value: number | string; label: string }>;
  /** ファイル */
  files: Array<ToukeiFile>;
}
</script>
